module.exports = __webpack_public_path__ + "img/notify_default.1adf0ab1.svg";